<template>
  <v-card class="elevation-1 mb-6 rounded-lg" min-width="280" max-width="320">
    <v-card-title class="pl-7 pr-7 pt-7">Operace</v-card-title>
    <v-card-actions class="pl-7 pr-7 pb-7">
      <v-row>
        <v-col cols="12" class="ma-0 pt-1 pb-1">
          <OrderTransferDialog @orderTransferred="orderTransferred()" />
          <v-btn
            type="submit"
            height="40px"
            depressed
            block
            color="primary"
            @click.prevent="openLabelDialog()"
          >
            Přidat štítek
          </v-btn>
        </v-col>
        <v-col cols="12" class="ma-0 pt-1 pb-1">
          <OrderTransferDialog @orderTransferred="orderTransferred()" />
          <v-btn
            type="submit"
            height="40px"
            depressed
            block
            color="primary"
            @click.prevent="openOrderTransferDialog()"
          >
            Převést na zákazníka
          </v-btn>
        </v-col>
        <v-col
          v-if="value.type.name === 'CALLBACK' || value.type.name === 'GENERAL_QUESTION'"
          cols="12"
          class="ma-0 pt-1 pb-1"
        >
          <v-btn
            type="submit"
            height="40px"
            depressed
            block
            color="primary"
            :to="{
              name: 'orders.assign',
              params: {
                assignId: value.id,
                customerId: value.customer.id,
              },
            }"
          >
            Převést na objednávku
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import OrderTransferDialog from '@/components/order/OrderTransferDialog'

export default {
  name: 'OrderActionForm',
  components: {
    OrderTransferDialog,
  },
  props: {
    value: {
      type: Object,
    },
  },
  methods: {
    openOrderTransferDialog() {
      this.$eventBus.$emit('orderTransferDialog', true)
    },
    orderTransferred() {
      this.$emit('update')
    },
    openLabelDialog() {
      this.$eventBus.$emit('addLabelDialog', true)
    },
  },
}
</script>
